import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonList } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
const LanguagePopover = ({ currentLang, alternateUrl }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const isCurrentLang = (language) => language === currentLang;
    const getLabel = (language) => `${t(`language.${language}`)} (${language.toUpperCase()})`;
    const buttons = Object.keys(alternateUrl)
        .map(lang => ({
        key: lang,
        active: isCurrentLang(lang),
        href: alternateUrl[lang],
        text: getLabel(lang),
    }))
        .sort((lang1, lang2) => Number(lang2.active) - Number(lang1.active));
    return _jsx(ButtonList, { buttons: buttons });
};
export { LanguagePopover };
